<div class="back-button">
    <a href="javascript:void(0)" (click)="goBack()">
        <img src="../../../../assets/svg/fi-rs-arrow-left.svg" alt="Back" loading="lazy">
    </a>
</div>
<div class="main-wrapper">
    <div class="reset-password-container">
        <div class="reset-password-center">
            <h2>{{ 'auth.reset-password.title' | translate }}</h2>
            <p class="reset-password-description">{{ 'auth.reset-password.description' | translate }}</p>
        </div>

        <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="reset-password-form"
            id="reset-password-form">
            <div class="form-group">
                <label for="password">{{ 'common.password' | translate }}</label>
                <div class="password-input-container">
                    <input [type]="getPasswordFieldType('password')" id="password" class="form-control"
                        formControlName="password" autocomplete>
                    <button type="button" class="toggle-password" (click)="togglePasswordVisibility('password')" aria-label="Toggle password visibility">
                        <img [src]="showPasswords ? '../../../assets/svg/show-password-icon.svg' : '../../../assets/svg/hide-password-icon.svg'"
                            [alt]="showPasswords ? 'Hide password' : 'Show password'" loading="lazy">
                    </button>
                    <span class="help-text">{{'auth.register.password-help' | translate}}</span>
                    <div class="error-message" *ngIf="shouldShowError('password')">
                        {{ getErrorMessage('password') }}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="re-type-password">{{ 'auth.re-type-password' | translate }}</label>
                <div class="re-type-password-input-container">
                    <input [type]="getPasswordFieldType('confirmPassword')" id="confirmPassword" class="form-control" formControlName="confirmPassword" autocomplete>
                    <button type="button" class="toggle-re-type-password"
                            (click)="togglePasswordVisibility('confirmPassword')" aria-label="Toggle password visibility">
                            <img [src]="showReTypePasswords ? '../../../assets/svg/show-password-icon.svg' : '../../../assets/svg/hide-password-icon.svg'"
                                [alt]="showReTypePasswords ? 'Hide password' : 'Show password'" loading="lazy">
                        </button>
                    <span class="help-text">{{'auth.register.re-type-password-help' | translate}}</span>
                    <div class="error-message" *ngIf="shouldShowError('confirmPassword')">
                        {{ getErrorMessage('confirmPassword') }}
                    </div>
                    <div class="error-message"
                        *ngIf="resetPasswordForm.errors?.['mismatch'] && (confirmPassword.touched || formSubmitted)">
                        {{'form.validation.passwords-not-match' | translate}}
                    </div>
                </div>
            </div>
            <button 
                type="submit" 
                class="reset-password-btn" 
                form="reset-password-form"
                [disabled]="resetPasswordForm.invalid || formSubmitted"
                [ngClass]="{'disabled': resetPasswordForm.invalid || formSubmitted}"
                aria-label="Reset password">
                {{ 'auth.reset-password.button-text' | translate }}
            </button>
        </form>
    </div>
</div>